// import React from "react";
// import {useTranslation} from "react-i18next";
// import NumberToPersianWord from "number_to_persian_word";

// function CustomDropdownWithSearch({props, state, methods}) {
//     const regexp = new RegExp(state.search, "i");
//     const regexp2 = new RegExp(NumberToPersianWord.convertEnToPe(`${state.search.toLocaleString()}`), "i");
//     const {t} = useTranslation();
    
//     return (
//         <div className={props.className}>
//             <div className="select_search_container">
//                 <i className="fa fa-search" aria-hidden="true"/>
//                 <input
//                     autoFocus
//                     type="text"
//                     value={state.search}
//                     onChange={(e)=> {
//                         methods.setSearch(e);
//                     }}
//                     onKeyDown={(e)=>{
//                         if (e.key === 'Enter') {
//                             let promiseArr=[];
//                             let exist=false;
//                             let tempOption={};
//                             props.options.forEach((obj,index) => {
//                                 promiseArr[index] = new Promise((resolve, reject) => {
//                                     if (obj.value?.toString() === state.search?.toString() && state.search?.toString()!==""){
//                                         exist=true;
//                                         tempOption=obj;
//                                         resolve();
//                                     }
//                                     else{
//                                         resolve();
//                                     }
//                                 });
//                             });
//                             Promise.all(promiseArr).then(() => {
//                                 if(exist){
//                                     methods.addItem(tempOption);
//                                 }
//                             });
//                         }
//                     }}
//                     placeholder={t("Search")}
//                 />
//             </div>
//             <div className="select_item_container">
//                 {props.options
//                     .filter(item =>
//                         regexp.test(item[props.searchBy] || item[props.labelField] || NumberToPersianWord.convertEnToPe(`${item[props.searchBy].toLocaleString()}`) || NumberToPersianWord.convertEnToPe(`${item[props.labelField].toLocaleString()}`)) ||
//                         regexp2.test(item[props.searchBy] || item[props.labelField] || NumberToPersianWord.convertEnToPe(`${item[props.searchBy].toLocaleString()}`) || NumberToPersianWord.convertEnToPe(`${item[props.labelField].toLocaleString()}`))
                        
//                     )
//                     .map(option => {
//                         let exist = "false";
//                         Object.values(state.values).forEach(obj => {
//                             if (obj.value === option.value)
//                                 exist = "true";
//                         });
//                         return (
//                             <div className="select_item"
//                                  item-selected={exist}
//                                  disabled={option.disabled}
//                                  key={option[props.valueField]}
//                                  onClick={
//                                      option.disabled ? null : () => methods.addItem(option)
//                                  }>
//                                 {option[props.labelField]}
//                             </div>
//                         );
//                     })}
//             </div>
//         </div>
//     );
// }

// export default CustomDropdownWithSearch;


import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import NumberToPersianWord from "number_to_persian_word";

function CustomDropdownWithSearch({ props, state, methods }) {
  const { t } = useTranslation();

  // مقدار جستجو را به صورت امن دریافت می‌کنیم (از null/undefined جلوگیری می‌کند)
  const searchText = state.search?.toString()?.trim() ?? "";
  
  // عبارات منظم برای جستجو – حساس به حروف کوچک/بزرگ نیستند
  const regexp = useMemo(() => new RegExp(searchText, "i"), [searchText]);
  const regexp2 = useMemo(() => {
    // فقط در صورت وجود متن جستجو، تبدیل به اعداد فارسی انجام شود
    const persianSearch = searchText ? NumberToPersianWord.convertEnToPe(searchText) : "";
    return new RegExp(persianSearch, "i");
  }, [searchText]);

  // تابع کمکی برای استخراج متن قابل جستجو (بدون تبدیل به فارسی)
  const getPlainSearchableText = (item) => {
    const primary = item[props.searchBy];
    if (primary != null) return primary.toString();
    const secondary = item[props.labelField];
    if (secondary != null) return secondary.toString();
    return "";
  };

  // تابع کمکی برای استخراج متن قابل جستجو (با تبدیل اعداد انگلیسی به فارسی)
  const getPersianSearchableText = (item) => {
    const primary = item[props.searchBy];
    if (primary != null) {
      return NumberToPersianWord.convertEnToPe(primary.toString());
    }
    const secondary = item[props.labelField];
    if (secondary != null) {
      return NumberToPersianWord.convertEnToPe(secondary.toString());
    }
    return "";
  };

  // فیلتر کردن گزینه‌ها بر اساس متن جستجو
  const filteredOptions = useMemo(() => {
    return props.options.filter((item) => {
      const plainText = getPlainSearchableText(item);
      const persianText = getPersianSearchableText(item);

      // اگر جستجو خالی باشد، همه موارد را نشان بده
      if (!searchText) return true;

      // بررسی انطباق با متن اصلی یا متن تبدیل‌شده به فارسی
      return regexp.test(plainText) || regexp2.test(persianText);
    });
  }, [props.options, props.searchBy, props.labelField, searchText, regexp, regexp2]);

  // تابع مدیریت جستجو هنگام فشردن Enter
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;

    // اگر عبارت جستجو خالی باشد، کاری نکن
    if (!state.search?.toString()) return;

    const exactMatch = props.options.find(
      (obj) => obj.value?.toString() === state.search?.toString()
    );

    if (exactMatch) {
      methods.addItem(exactMatch);
    }
  };

  return (
    <div className={props.className}>
      <div className="select_search_container">
        <i className="fa fa-search" aria-hidden="true" />
        <input
          autoFocus
          type="text"
          value={state.search ?? ""}
          onChange={(e) => methods.setSearch(e)}
          onKeyDown={handleKeyDown}
          placeholder={t("Search")}
        />
      </div>
      <div className="select_item_container">
        {filteredOptions.map((option) => {
          // بررسی می‌کند که آیا این گزینه قبلاً انتخاب شده است
          const isSelected = Object.values(state.values).some(
            (obj) => obj.value === option.value
          );
          const selectedAttr = isSelected ? "true" : "false";

          return (
            <div
              className="select_item"
              item-selected={selectedAttr}
              disabled={option.disabled}
              key={option[props.valueField]}
              onClick={option.disabled ? null : () => methods.addItem(option)}
            >
              {option[props.labelField]}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CustomDropdownWithSearch;